<template>
  <div class="qianyan-container">
    <custom-router-link :item="info" class="qianyan-link" :to="{name: 'HomeDetails', params: {id: info.id}}" target="_blank">
      <div class="qianyan-image">
        <el-image :src="projectFileUrl + info.image" fit="cover" v-if="info.image"></el-image>
        <el-image :src="require('@/assets/images/img2.png')" fit="cover" v-else></el-image>
      </div>
      <div class="qianyan-details">
        <div class="qianyan-title">{{info.name}}</div>
        <!-- <div class="qianyan-summary">{{info.summary}}</div> -->
        <div class="publish-time">{{info.publishTime && info.publishTime.split(" ")[0]}}</div>
      </div>
    </custom-router-link>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  props: {
    info: {
      type: Object,
      default: () => { }
    }
  },
  components: {

  },
  mounted() {

  },
  methods: {

  },
}
</script>

<style lang="less" scoped>
.qianyan-container {
  width: 100%;
  .qianyan-link {
    display: flex;
    flex-direction: column;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.02);
    .qianyan-image {
      width: 100%;
      height: 134px;
      .el-image {
        width: 100%;
        height: 100%;
      }
    }
    .qianyan-details {
      width: 100%;
      padding: 14px;
      .qianyan-title {
        font-weight: 600;
        font-size: 20px;
        line-height: 28px;
        height: 56px;
        margin-bottom: 10px;
        color: #212529;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        display: -webkit-box;
        -webkit-box-orient: vertical;
      }
      .qianyan-summary {
        width: 100%;
        font-size: 15px;
        height: 40px;
        color: #6c757d;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        display: -webkit-box;
        -webkit-box-orient: vertical;
      }
    }
    .publish-time {
      font-size: 14px;
      line-height: 22px;
      color: #6c757d;
      margin-top: 10px;
    }
  }
}

@media screen and (max-width: 768px) {
  .qianyan-container {
    .qianyan-link {
      box-shadow: 0px 0px 2px 2px rgba(0, 0, 0, 0.04);
      .qianyan-image {
        width: 100%;
        height: auto;
        aspect-ratio: 2/1;
        overflow: hidden;
      }
      .qianyan-details {
        width: 100%;
        padding: 14px;
        .qianyan-title {
          font-size: 18px;
          line-height: 24px;
          height: 48px;
          margin-bottom: 6px;
        }
        .qianyan-summary {
          font-size: 13px;
          line-height: 20px;
        }
      }
      .publish-time {
        font-size: 12px;
        line-height: 18px;
        margin-top: 8px;
      }
    }
  }
}
</style>